<script setup lang="ts">
defineProps<{ title: string }>();
</script>

<template>
  <header class="gallery-page-header">
    <h1 class="section_title">{{ title }}</h1>
  </header>
</template>

<style scoped>
.gallery-page-header { margin-bottom: clamp(1.5rem, 3vw, 2rem); }
.section_title { margin: 0; padding-bottom: 1rem; text-align: center; overflow-wrap: anywhere; }
.section_title::after { top: auto; bottom: 0; left: 50%; width: 3rem; transform: translateX(-50%); }
</style>
